import React, { FC } from 'react';
import './styles.scss';
import { getSimpleDateFormat, formatTime } from 'utils/functions';
import { MealCategoryType, SearchType } from 'utils/types';
import { Link } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';

type Props = {
  data: MealCategoryType | SearchType;
  className?: string;
};

const ItemCategoryCard: FC<Props> = ({ data, className }) => {
  const { routePrefix } = useDashboardContext();
  return (
    <div
      className={`meal-category py-[14px] px-[20px] rounded border border-[#FAFAFA] ${className}`}>
      <div>
        <div className=' flex justify-between items-start'>
          <div>
            <p className='leading-[22px] text-sm font-medium'>{data.name ?? ''}</p>
            <p className='pb-[20px] text-[#858585] text-xs'>
              Created&nbsp;
              <span className='mr-[4px]'>{getSimpleDateFormat(data.created_at ?? '')},</span>
              <span>{formatTime(new Date(data.created_at ?? ''))}</span>
            </p>
          </div>
        </div>

        <Link to={`${routePrefix}/items/${data.id}`}>
          <span className='font-medium text-[#E60A2B] text-xs underline cursor-pointer'>
            View items
          </span>
        </Link>
      </div>
    </div>
  );
};

export default ItemCategoryCard;
